// Note: The first file of a module here, must also register the module

import "./android-mockup.component";
import "./customize.component";
import "./iphone-mockup.component";
import "./mockup-pane.component";
